<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Atestado"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-select
                        :options="data.form.atestado.modelos"
                        :validations="validations.modelo"
                        @change="handleModeloChange"
                        label="Modelo"
                        text-field="nome"
                        v-model="model.modeloId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col
                    v-if="model.modeloId === enums.atestadoModelo.PADRAO"
                    cols="8"
                >
                    <rkm-form-input
                        :readonly="!model.isAtestadoAcompanhante"
                        :validations="validations.nome"
                        label="Nome"
                        uppercase
                        v-model="model.nome"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-radio-group
                                    @change="handleisAtestadoAcompanhanteChange"
                                    v-model="model.isAtestadoAcompanhante"
                                >
                                    <rkm-form-radio :value="false">Paciente</rkm-form-radio>
                                    <rkm-form-radio :value="true">Acompanhante</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <template v-if="model.modeloId === enums.atestadoModelo.PADRAO">
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="documentoTipos"
                            @change="handleDocumentoTipoChange"
                            default-option-text="Não possui"
                            label="Tipo de documento"
                            show-default-option
                            text-field="nome"
                            v-model="model.documentoTipoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <template v-if="model.documentoTipoId">
                        <rkm-col
                            v-if="model.documentoTipoId === enums.documentoTipo.CPF"
                            cols="6"
                        >
                            <rkm-form-input
                                :disabled="!model.isAtestadoAcompanhante"
                                :validations="validations.cpf"
                                label="CPF"
                                v-mask="mask.cpf"
                                v-model="model.cpf"
                            />
                        </rkm-col>

                        <rkm-col
                            v-else-if="model.documentoTipoId === enums.documentoTipo.CNS"
                            cols="6"
                        >
                            <rkm-form-input
                                :disabled="!model.isAtestadoAcompanhante"
                                :validations="validations.cns"
                                label="CNS"
                                v-mask="mask.cns"
                                v-model="model.cns"
                            />
                        </rkm-col>
                    </template>
                </template>
            </rkm-row>

            <template v-if="model.modeloId === enums.atestadoModelo.PADRAO">
                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-date-picker
                            :max-date="data.additionals.dataAtual"
                            :validations="validations.data"
                            label="Data"
                            v-model="model.data"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-time-picker
                            :validations="validations.horario"
                            label="Horário"
                            v-model="model.horario"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input
                            :validations="validations.dias"
                            label="Dias"
                            number
                            v-model="model.dias"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>

                    <rkm-col cols="12" v-if="!model.sugestao">
                        <rkm-form-input-autocomplete
                            :repository="repositories.cid"
                            :request-query-string-params="{
                                sexo: data.additionals.paciente.sexoIdentificador,
                            }"
                            :results-limit= "20"
                            :search-fields="fields"
                            :text-field="(item) => `${item.codigo} - ${item.nome}`"
                            label="CID 10"
                            v-model="model.cid"
                        >

                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    <rkm-form-radio-group
                                        v-model="model.sugestao"
                                        :disabled="data.cidSugestao.length === 0"
                                    >
                                        <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                        <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                    </rkm-form-radio-group>
                                </rkm-input-group-text>
                            </rkm-input-group-append>
                        </rkm-form-input-autocomplete>
                    </rkm-col>

                    <rkm-col cols="12" v-else>
                        <rkm-form-select
                            :options="data.cidSugestao"
                            label="CID 10"
                            show-default-option
                            text-field="codigoNome"
                            v-model="model.cidId"
                            value-field="id"
                        >

                            <rkm-input-group-append slot="append">
                                <rkm-input-group-text>
                                    <rkm-form-radio-group v-model="model.sugestao">
                                        <rkm-form-radio :value="true">Sugestão</rkm-form-radio>
                                        <rkm-form-radio :value="false">Novo</rkm-form-radio>
                                    </rkm-form-radio-group>
                                </rkm-input-group-text>
                            </rkm-input-group-append>
                        </rkm-form-select>
                    </rkm-col>
                </rkm-row>
            </template>

            <rkm-row v-else>
                <rkm-col>
                    <rkm-form-textarea
                        :validations="validations.descricao"
                        label="Descrição"
                        rows="4"
                        v-model="model.descricao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                {{item ? 'Salvar' : 'Incluir'}}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Enums.
import atestadoModelo from '@/enums/ambulatorio/atestadoModelo'
import documentoTipo from '@/enums/cadastro/documentoTipo'

// Mixins.
import {formats, object, mask, repository, unmask} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters({lotacao: 'getLotacao'}),
        documentoTipos() {
            return this.data.form.atestado.documentoTipos.filter(documentoTipo => {
                if (this.model.isAtestadoAcompanhante) {
                    return documentoTipo.id === this.enums.documentoTipo.CPF
                }

                return true
            })
        },
        validations() {
            return {
                nome: {
                    required: true,
                    max: 150,
                },
                cpf: {
                    required: true,
                    cpf: true,
                },
                cns: {
                    required: true,
                    cns: true,
                },
                data: {required: true},
                horario: {required: true},
                dias: {
                    required: true,
                    max: 3,
                },
                descricao: {
                    required: true,
                    max: 500,
                }
            }
        },
    },
    created() {
        this.repositories = {
            cid: this.getConectaSusRepository('sigtap.cid'),
        }
    },
    data: () => ({
        enums: {
            atestadoModelo,
            documentoTipo,
        },
        fields: [
            {key: 'codigo', searchable: true},
            {key: 'nome', searchable: true},
        ],
        item: null,
        model: {
            modeloId: atestadoModelo.PADRAO,
            nome: null,
            isAtestadoAcompanhante: false,
            documentoTipoId: documentoTipo.CPF,
            cpf: null,
            cns: null,
            data: null,
            horario: null,
            dias: null,
            cid: null,
            cidId: null,
            descricao: null,
            sugestao: false,
        },
        others: {moment},
    }),
    methods: {
        open(item = null) {
            this.item = item

            if (this.item) {
                this.edit()
            } else {
                this.create()
            }

            this.model.sugestao = this.data.cidSugestao.length > 0

            this.$refs.RkmModal.show()
        },
        create() {
            this.resetForm()

            this.model.data = this.others.moment(this.data.additionals.dataAtual, 'DD/MM/YYYY').toDate()
            this.model.horario = this.data.additionals.horaInicioAtendimento
        },
        edit() {
            this.model = this.clone({
                modeloId: this.item.modeloId,
                nome: this.item.nome,
                isAtestadoAcompanhante: this.item.isAtestadoAcompanhante,
                documentoTipoId: this.item.documentoTipoId,
                cpf: this.item.cpf,
                cns: this.item.cns,
                data: this.item.data ? this.others.moment(this.item.data, 'DD/MM/YYYY').toDate() : null,
                horario: this.item.horario,
                dias: this.item.dias,
                cid: this.item.cid,
                cidId: this.data.cidSugestao.length > 0 ? this.item.cid.id : null,
                descricao: this.item.descricao,
                sugestao: false,
            })
        },
        store() {
            this.data.model.atestados.push(this.prepareData())
        },
        update() {
            Object.assign(this.item, this.prepareData())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.item) {
                        this.update()
                    } else {
                        this.store()
                    }

                    this.$refs.RkmModal.hide()
                })
        },
        prepareData() {

            let cid = null

            if (this.model.sugestao) {

                const cidSelecionado = this.data.cidSugestao.find(c => c.id == this.model.cidId)

                if (cidSelecionado) {

                    cid = {
                        id: cidSelecionado.id,
                        codigo: cidSelecionado.codigo,
                        nome: cidSelecionado.nome,
                    }
                }
            } else {

                cid = this.model.cid ? {
                    id: this.model.cid.id,
                    codigo: this.model.cid.codigo,
                    nome: this.model.cid.nome,
                } : null
            }

            return {
                modeloId: this.model.modeloId,
                nome: this.model.nome,
                isAtestadoAcompanhante: this.model.isAtestadoAcompanhante,
                documentoTipoId: this.model.documentoTipoId,
                cpf: this.model.cpf,
                cns: this.model.cns,
                data: this.model.data ? this.others.moment(this.model.data).format('DD/MM/YYYY') : null,
                horario: this.model.horario ? this.formatTime(this.model.horario) : null,
                dias: this.model.dias,
                cid: cid,
                descricao: this.model.descricao,
                usuario: {
                    id: this.lotacao.usuario.id,
                    nome: this.lotacao.usuario.nome,
                },
            }
        },
        resetForm() {
            const paciente = this.data.additionals.paciente

            this.model.nome = this.data.additionals.paciente.nome
            this.model.isAtestadoAcompanhante = false
            this.model.modeloId = this.enums.atestadoModelo.PADRAO
            this.model.documentoTipoId = this.enums.documentoTipo.CPF
            this.model.cpf = paciente.cpf ? paciente.cpf : null
            this.model.cns = paciente.cns ? paciente.cns : null
            this.model.data = null
            this.model.horario = null
            this.model.dias = null
            this.model.cid = null
            this.model.cidId = null
            this.model.descricao = null
            this.model.sugestao = false
        },
        handleisAtestadoAcompanhanteChange(value) {
            if (value) {
                this.model.nome = null
                this.model.cpf = null
                this.model.cns = null
            } else {
                const paciente = this.data.additionals.paciente

                this.model.nome = paciente.nome
                this.model.cpf = paciente.cpf ? paciente.cpf : null
                this.model.cns = paciente.cns ? paciente.cns : null
            }
        },
        handleModeloChange() {
            const paciente = this.data.additionals.paciente

            this.model.nome = this.data.additionals.paciente.nome
            this.model.isAtestadoAcompanhante = false
            this.model.documentoTipoId = this.enums.documentoTipo.CPF
            this.model.cpf = paciente.cpf ? paciente.cpf : null
            this.model.cns = paciente.cns ? paciente.cns : null
            this.model.data = null
            this.model.horario = null
            this.model.dias = null
            this.model.cid = null
            this.model.cidId = null
            this.model.descricao = null
            this.model.sugestao = false
        },
        handleDocumentoTipoChange() {
            const paciente = this.data.additionals.paciente

            if (!this.model.isAtestadoAcompanhante) {
                this.model.cpf = paciente.cpf ? paciente.cpf : null
                this.model.cns = paciente.cns ? paciente.cns : null
            }
        },
    },
    mixins: [formats, object, mask, repository, unmask],
    props: {
        data: {required: true, type: Object},
    },
}
</script>